/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateScriptStepRequest
 */
export interface UpdateScriptStepRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptStepRequest
     */
    heading?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScriptStepRequest
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateScriptStepRequest
     */
    order?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateScriptStepRequest
     */
    fieldIds?: Array<number>;
}

/**
 * Check if a given object implements the UpdateScriptStepRequest interface.
 */
export function instanceOfUpdateScriptStepRequest(value: object): boolean {
    return true;
}

export function UpdateScriptStepRequestFromJSON(json: any): UpdateScriptStepRequest {
    return UpdateScriptStepRequestFromJSONTyped(json, false);
}

export function UpdateScriptStepRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScriptStepRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'heading': json['heading'] == null ? undefined : json['heading'],
        'content': json['content'] == null ? undefined : json['content'],
        'order': json['order'] == null ? undefined : json['order'],
        'fieldIds': json['fieldIds'] == null ? undefined : json['fieldIds'],
    };
}

export function UpdateScriptStepRequestToJSON(value?: UpdateScriptStepRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'heading': value['heading'],
        'content': value['content'],
        'order': value['order'],
        'fieldIds': value['fieldIds'],
    };
}

